import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/users")({
  component: RouteComponent,
  beforeLoad() {
    // users requires a justification session
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="users:view">
      <Outlet />
    </PermissionGuard>
  );
}
